import script from "./TokenCollapse.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenCollapse.vue?vue&type=script&setup=true&lang=ts"

import "./TokenCollapse.vue?vue&type=style&index=0&id=23f4f324&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f4f324"]])

export default __exports__